import { demoteOrganisationRole } from '@infuse/api/iam/organisation';
import { useGenericDemoteRole } from '@infuse/iam/role/mutations';

export const useDemoteOrganisationRole = () => {
  return useGenericDemoteRole({
    apiFn: demoteOrganisationRole
  });
};
